if (typeof UseSwStat == 'undefined' || typeof UseSwStat == 'null') {
    var UseSwStat = false;
}



if (typeof UseTagManager == 'undefined' || typeof UseTagManager == 'null') {
    UseTagManager = false;
}

function setContentHeight() {
    if ($(window).width() < 768) {
        var ContentHeight = $(".SepetProducts").height() - 310;
        $(".BasketCenterContent").height(ContentHeight);
        $(".BasketCenterContent").css("max-height", ContentHeight);
    } else {
        var ContentHeight2 = $(".SepetProducts").height() - 360;
        $(".BasketCenterContent").height(ContentHeight2);
        $(".BasketCenterContent").css("max-height", ContentHeight2);
    }


    $(window).resize(function () {
        if ($(window).width() < 768) {
            var ContentHeight3 = $(".SepetProducts").height() - 310;
            $(".BasketCenterContent").height(ContentHeight3);
            $(".BasketCenterContent").css("max-height", ContentHeight3);
        } else {
            var ContentHeight4 = $(".SepetProducts").height() - 360;
            $(".BasketCenterContent").height(ContentHeight4);
            $(".BasketCenterContent").css("max-height", ContentHeight4);
        }

    });

}

function toggleBasket() {


    if ($(".SepetProducts").is(":visible")) {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
        });
    } else {
        $(".SepetProducts").stop().animate({ "left": "79%" }, 200, function () {
            $(".SepetProducts").stop().show();
            setContentHeight();
            $("body").addClass("BasketDropped");
        });
    }

}

function TagAutoComplate() {


    if ($(".SearchModal").length > 0) {

        $(".SearchModal input:first").autocomplete({

            source: "/" + $("#SmallLangCode").val() + "/p/Cat/CompleteNames",
            minLength: 2,
            select: function (event, ui) {



                if (ui.item.FilterType == "Product") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/" + ui.item.HexValue;
                }

                if (ui.item.FilterType == "Tag" || ui.item.FilterType == "Color") {
                    window.location.href = "/" + $("#SmallLangCode").val() + "/p/Cat/NewSearch?sr=" + ui.item.MainValue;
                }

                //$(".SearchModal input:first").val(ui.item.value);
                //$(".SearchModal form").submit();

            }
            ,
            create: function () {


                $(this).data('ui-autocomplete')._renderItem = function (ul, item) {


                    if (item.FilterType == "Product") {
                        $li = $('<li class="PrItem">').append('<img src="' + item.ImagePath + '" alt="" />');

                        $li.append("<span class='PrHeader'>" + item.SubValue + "</span>");
                        $li.append("<span>" + item.MainValue + "</span>");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }

                    if (item.FilterType == "Color") {
                        $li = $('<li class="ColorItem">').append('<span class="HexItem" style="background-color:#' + item.HexValue + '" alt="" />');

                        $li.append("<div class='ColorHeader'>" + item.MainValue + "</span><span>Renklerde Arayın</span>");
                        $li.append("");
                        $li.append("<span class='Info'></span>");

                        $li.appendTo(ul);

                        return $li;

                    }
                    else {


                        return $('<li>')
                            .append(item.MainValue)
                            .appendTo(ul);
                    }

                };
            },
            focus: function (event, ui) {

                event.preventDefault();
                $(".SearchModal form input:first").val(ui.item.MainValue);

            }

        });
    }
}

function GetHelp(x) {

    $('.help_div').hide();
    $('.help_' + x).show();


    $('.help_' + x).children("div.subhelp:first").show();


}

function changeSiteLanguage(langID, langCode) {

    var url = "/";
    var Catalogs = $("#PgCatalogs").val().split("/");
    var ctlgs = "";

    for (var i = 0; i < Catalogs.length; i++) {
        if (Catalogs[i].length > 0) {
            ctlgs += "&Cats=" + Catalogs[i];
        }
    }

    $.ajax({
        type: 'get',
        url: '/Home/ChangePageLang',
        data: 'PID=' + $("#PID").val() + "&PgType=" + $("#PgType").val() + "&AName=" + $("#AName").val() + "&CName=" + $("#CName").val() + "&langID=" + langID + ctlgs + "&langCode=" + langCode,
        success: function (dt) {
            window.parent.location.href = dt;
        }
    });

}

function changeSiteTheme(layout) {

    //var hs = window.location.hash;
    //hs = hs.replace("=", "[_]");
    //hs = hs.replace("&", "[and]")

    $.ajax({
        type: 'get',
        url: '/Home/ChangeTheme',
        data: 'Url=' + window.location.pathname + "&th=" + layout + "&hash=" + window.location.hash,
        success: function (dt) {

            window.parent.location.href = dt;
        }
    });

}

function ShowLangAreaForChange() {


    var userLang = navigator.language || navigator.userLanguage;

    if (userLang != null && userLang != undefined && userLang.length > 2) {

        userLang = userLang.substr(0, 2).toLowerCase();
    }

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowLangSwitch",
        success: function (data) {

            if ($(".LangSelectionArea").length <= 0) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".LangSelectionArea").hasClass("gizle")) {

                if (document.URL.indexOf("localhost") >= 0) {

                    $(".LangSelectionArea").show();
                }

            } else {

                $(".LangSelectionArea").hide();
            }

        }
    });

}

function ShowCurrencyForChange() {


    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/Home/ShowCurrencySwitch",
        success: function (data) {

            if ($(".CurrrencySelectionArea").length <= 0) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".FixedHeader > .container:first").prepend(data);
                }

            } else if ($(".CurrrencySelectionArea").hasClass("gizle")) {

                if ($(".AllowCurrencyChange").length > 0) {

                    $(".CurrencySelectionArea").show();
                }


            } else {

                $(".CurrrencySelectionArea").hide();
            }

        }
    });

}

function SetWindowSize() {
    //$.ajax({
    //    type: "GET",
    //    url: "/" + $("#SmallLangCode").val() + "/p/User/SetUserWindowSize?u.Width=" + $(window).width() + "&u.Height=" + $(window).height(),
    //    cache: false,
    //    success: function (cdt) {

    //    }
    //});

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }
}

var mouse_is_inside_search = false;
var mouse_is_inside_userandBasket = false;
var mouse_is_inside_LeftMenu = false;
var mouse_is_inside_MainMenu = false;

function HideOpenWindows() {

    if (!mouse_is_inside_search) {

        $(".SearchModal").hide();

    }

    if (!mouse_is_inside_userandBasket) {

        $(".RightBasket").removeClass("active");
        $(".RightAccount ").removeClass("active");
        $("ul#MainMenu.Monitor > li").removeClass("open");

    }

    if (!mouse_is_inside_search && !mouse_is_inside_userandBasket && !mouse_is_inside_LeftMenu) {

        //$("body").removeClass("BackDropped");
    }

    if (!mouse_is_inside_MainMenu) {
        $("ul#MainMenu.Monitor > li").removeClass("open");
    }

}

$('.SearchModal form, .RightSearch').live({
    mouseenter:
        function () {
            mouse_is_inside_search = true;
        },
    mouseleave:
        function () {
            mouse_is_inside_search = false;
        }
});

$('.SubMenuContainer, #MainMenu').live({
    mouseenter:
        function () {
            mouse_is_inside_MainMenu = true;
            $(".FilterOption .slider").hide();
        },
    mouseleave:
        function () {
            mouse_is_inside_MainMenu = false;
            $(".FilterOption .slider").show();
        }
});


$.fn.exists = function () {
    return this.length !== 0;
}

var lastpos = -1;
var showTopLink = 100;
var width = 0;
var UserValue;

function LoginIcon() {
    $(".LoginIcon").on("click", function () {
        $("#RegisterLoginModal").modal();
    });
}

function MenuMouseOver() {
    $("#MainMenu > ul > li").on("mouseover", function () {
        $("body").addClass("BackDropped");
    });
}


function RegisterLoginModal() {

    $(".RightAccount #AccountLink").live("click", function () {
        if ($("#AccountMenu").length <= 0) {
            $("#RegisterLoginModal").modal("toggle");
        }
    });

    $(".card-define-button").live("click", function () {

        $("div.RegisterRow").hide();
        $("div.LoginRow").hide();
        $("div.Site1Control").show();
        $("span.ControlResult").hide();
        $("div#AlertResult").hide();

        // mobilde membercard bölümü scroll top olmalı.
        if ($(window).width() < 768) {
            $('#RegisterLoginModal').animate({ scrollTop: 0 }, 'slow');
        }
    });

    $(".create-user-button").live("click", function () {

        if ($(".leftColumn > span > span.selected").html() == "Giriş Yap") {

            $("div.RegisterRow").hide();
            $("div.LoginRow").show();
            $("div.Site1Control").hide();
            $("span.ControlResult").hide();
            $("span.CreateUsrText").show();

        }

        else if ($(".leftColumn > span > span.selected").html() == "Yeni Üyelik") {

            $("div.RegisterRow").show();
            $("div.LoginRow").hide();
            $("div.Site1Control").hide();
            $("span.ControlResult").hide();
            $("span.CreateUsrText").hide();
        }

        $(".create-user-button > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        $(".leftColumn > span > span").each(function () {
            if ($(this).hasClass("selected")) {
                $(this).removeClass("selected");
            }
            else {
                $(this).addClass("selected");
            }
        });

        if ($(window).width() < 768) {
            $('#RegisterLoginModal').animate({ scrollTop: 0 }, 'slow');
        }

        //$(".UyeKayitCol > div").each(function () {
        //    if ($(this).hasClass("selected")) {
        //        $(this).removeClass("selected");
        //    }
        //    else {
        //        $(this).addClass("selected");
        //    }
        //});



    });


    $(".modal-close-button").live("click", function () {
        $("#RegisterLoginModal").modal("toggle");
        $("body").removeClass("BackDropped");
    });


    $('#RegisterLoginModal').on('show.bs.modal', function () {
        $(".UyeKayitCol > div").removeClass("selected");
        $(".UyeKayitCol .LoginRow").addClass("selected");
        $(".create-user-button span").removeClass("selected");
        $(".create-user-button .createUser").addClass("selected");
        $("header").addClass("LoginModal");
        $("#AlertResult").hide();
    });




    $('#RegisterLoginModal').on('hidden.bs.modal', function () {

        $("header").removeClass("LoginModal");
        $("#AlertResult").hide();

    });

}

function MenuBannerSettings() {
    $DefaultImage = "";

    $(".ListWrapper > ul > li").hover(function () {
        $BannerArea = $(this).parent().parent().parent().find(".MenuBanner > img");
        $DefaultImage = $BannerArea.attr("src");

        if ($(this).data("img") != "" && $(this).data("img") != null) {
            $BannerArea.attr("src", $(this).data("img"));

        }
    }, function () {
        if ($DefaultImage != null) {
            $BannerArea.attr("src", $DefaultImage);
        }
    });

}

function ToggleFooterMenu() {
    $(".footerContactWrapper .footerMenu").live("click", function () {
        $(this).find("ul").slideToggle();
    });
}

function Isfollow() {

    var ProductID = $("#ProductID").val();
    $That = $(".AddToFavorite");

    if (ProductID != undefined) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/IsFollow",
            data: 'ProductID=' + ProductID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.IsFollow == true) {
                    $That.removeClass("passiveFavorite");
                    $That.addClass("activeFavorite");
                } else {
                    $That.addClass("passiveFavorite");
                    $That.removeClass("activeFavorite");
                }



            }
        });
    }

}

function GetMemberCardPrice() {

    var Amount = $("#ForMemberCardAmount").val();
    var OldAmount = $("#ForMemberCardOldAmount").val();
    var MemberCardGroupID = $("#MemberCardGroupID").val();
    var ForMemberCardCurrencyCode = $("#ForMemberCardCurrencyCode").val();

    if (Amount != undefined && OldAmount != undefined && MemberCardGroupID != undefined && ForMemberCardCurrencyCode != undefined && MemberCardGroupID != -1) {
        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetMemberCardPrice",
            data: 'Amount=' + Amount + "&AmountOld=" + OldAmount + "&MemberCardGroupID=" + MemberCardGroupID,
            dataType: 'json',
            async: true,
            success: function (dt) {
                if (dt.TotalAmount != "0" && dt.TotalAmount != 0) {
                    $(".RPrice").html(dt.TotalAmount + " " + ForMemberCardCurrencyCode);
                    $(".MemberCardPrice").css("display", "inline-block");
                }

            }
        });
    }

}
function MobileMenuSetting() {

    $("#MainMenu > ul > li").each(function () {
        if ($(this).find(".itemsWrapper").length > 0 && !$(this).hasClass("TabletMenu")) {
            $(this).addClass("plus-icon");
            if ($(window).width() < 768) {
                $(this).find("a:first").attr("href", "javascript:;");
            }
        }
    });

    // if ($(window).width() < 768) {
    //     $("#MainMenu > ul > .plus-icon a:first")
    // }

}

function AddToFavorite() {


    $(".passiveFavorite").live("click", function () {
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ColorID != undefined && ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                    }


                }
            });
        }
    });


}

function removeFavorite() {
    $(".activeFavorite").live("click", function () {
        var ProductID = $("#ProductID").val();
        $That = $(this);
        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + "&IsDetail=true",
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                    }


                }
            });
        }
    });
}

function ModalOpenRM() {
    $(".AccountOpen #CardLink").live("click", function () {

        $("#RegisterLoginModal").modal("toggle");

    });
}

function ChangePlaceholderSearch() {

    if ($(window).width() <= 500) {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aradığınız ürün burada.");
    } else {

        $('.fullSearch input[type="search"]').attr("placeholder", "Aramak istediğiniz kelimeyi giriniz.");
    }
}

$(window).resize(ChangePlaceholderSearch).trigger('resize');

function CreateSegmentifyObject($type) {

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/Home/GetSegmentifyObject",
        data: "objectType=" + $type,
        dataType: 'json',
        async: true,
        success: function (dt) {
            if (dt.email != "notLogin") {
                window.segUserObject = jQuery.parseJSON(dt);
            }
        }
    });
}

// Hareket Algılamadığı sürece 5 dakikada bir sayfa yenilenir
function RefreshPage() {
    var start = new Date;

    setInterval(function () {
        $(window).scroll(function (event) {
            start = new Date;
        });

        var HowLong = (new Date - start) / 1000;

        if (HowLong > 300) {
            location.reload();
        }
    }, 1000);
}

function ShowMenuImage() {
    if ($(window).width() > 992) {

        $("#MainMenu > ul > li").hover(function () {

            $BannerImage = $(this).find(".MenuBanner img");

            if ($BannerImage.attr("data-oimage") != undefined) {

                var Oiamge = $BannerImage.attr("data-oimage");
                $BannerImage.attr("src", Oiamge);
                $BannerImage.removeAttr("data-oimage");
            }

        });

    }
}

$(document).ready(function () {

    //RefreshPage();

    $(".NewHome header").mouseenter(function () {
        $(".NewHome header").addClass("mouseOn");
    });

    $(".NewHome header").mouseleave(function () {
        $(".NewHome header").removeClass("mouseOn");
    });

    if ($(window).width() < 767) {

        var langCode = $("#SmallLangCode").val();

        var link = "https://www.trendtesettur.com/tr/tesettur-giyim";

        var linkEkatalog = "https://www.alvinaonline.com/ekatalog";

        var LinkText = "Trend Fırsat Ürünleri";

        var LinkEKatalogText = "‘22-‘23 Kış Katalog";

        if (langCode == "en") {
            link = "https://www.trendtesettur.com/en/new-season";
            LinkText = "Trend Opportunity Products";
            LinkEKatalogText = "‘22-‘23 Winter Catalog";
        }
        else if (langCode == "fr") {
            link = "https://www.trendtesettur.com/fr/nouvelle-saison";
            LinkText = "Produits d'opportunité tendance";
            LinkEKatalogText = "Catalogue Hiver ‘22-‘23";
        }

        var TrendItem = "<li><a href='" + link + "' style='color:#f00; font-weight:bold !important'>" + LinkText + "</a></li>";

        var EKatalogItem = "<li><a href='" + linkEkatalog + "' style='color:#f00; font-weight:bold !important'>" + LinkEKatalogText + "</a></li>";

        $("#MainMenu > ul.Mainmenu").append(TrendItem);

        //$("#MainMenu > ul.Mainmenu").append(EKatalogItem);
    }

    //CreateSegmentifyObject("Login");

    //$("#SingOut").live("click", function () {
    //    CreateSegmentifyObject("Logout");
    //});

    if ($(window).width() < 992) {
        ToggleFooterMenu();
    }

    $('.footerMenu .mainHead').click(function () {
        $(this).parent().toggleClass("open");
    });

    ShowMenuImage();
    RegisterLoginModal();
    ModalOpenRM();
    ChangePlaceholderSearch();

    $(".carousel").live("swiperight", function () { //lazım olursa ekleriz   .die("swiperight").live("swiperight", function () {
        $(this).carousel('prev');

        $nextImage = $(this).find(".prev").find(".PImage");
        if ($nextImage.attr("src").indexOf("lazy_back_new.jpg") != -1) {
            $nextImage.attr("src", $nextImage.attr("data-img"));
        }

        e.preventDefault();
        return false;
    });
    $(".carousel").live("swipeleft", function () {  //.die("swipeleft").live("swipeleft", function () {
        $(this).carousel('next');

        $nextImage = $(this).find(".next").find(".PImage");

        if ($nextImage.attr("src").indexOf("lazy_back_new.jpg") != -1) {
            $nextImage.attr("src", $nextImage.attr("data-img"));
        }

        e.preventDefault();
        return false;
    });

    $("#MainMenu > ul > li").on("mouseover", function () {
        $($(this).children(".itemsWrapper").children(".ListWrapper").children("ul").children("li")).each(function (i) {
            if ($(this).find("div").length > 0) {
                $(this).parent().css('font-weight', 'bold');
            }
            else {
                $(this).children().css('font-weight', 'normal');
                $(this).children().css('text-transform', 'none');
            }
        });

        $($(this).children(".itemsWrapper").children(".ListWrapper").find(".list_left")).each(function (i) {
            if ($(this).children().length < 1) {
                $(this).css("display", "none");
            }
        });
        $($(this).children(".itemsWrapper").children(".ListWrapper").find(".list_right")).each(function (i) {
            if ($(this).children().length < 1) {
                $(this).css("display", "none");
            }
        });
    });

    $("#Site1ControlButton").live("click", function () {
        $.ajax({

            type: "POST",
            url: "/tr/p/User/MemberCardControl?NameSurname=" + $("#NameSurname").val() + "&PhoneNumber=" + $("#Phone").val() + "&Email=" + $("#Email").val(),
            cache: false,
            success: function (data) {


                if (data > 0) {

                    $("div.MemberCardPlace").hide();
                    $("span.ControlResult").css("display", "block");
                    $("span.ControlResult").html('<br/><div class="alert alert-danger">MemberCard sahibisiniz. Üye girişi yaparak avantajlardan yararlanabilirsiniz</div>');
                    $("div.LoginRow").css("display", "block");
                }
                else if (data == -1) {
                    $("span.ControlResult").show().html('<br/><div class="alert alert-danger">Lütfen tüm alanları eksiksiz doldurunuz.</div>');

                }
                else if (data.StatusCode == -2) {

                    $("div.MemberCardPlace").hide();
                    $("div.RegisterRow").show();
                    $("form.UyeOlModal #LoginNameSurname").val(data.Name);
                    $("form.UyeOlModal #LoginEposta").val(data.Email);
                    $("form.UyeOlModal #UserGsm").val(data.Mobile);
                    $("form.UyeOlModal #LoginPassword").val("");

                    $("span.ControlResult").show().html('<div class="alert alert-danger">Üyelik Kartı tanımlamak için önce üye olunmalıdır.</div>');
                }
                else {

                    $("div.MemberCardPlace").hide();
                    $("span.ControlResult").show().html('<br/><br/><br/><div class="alert alert-danger"> <strong>Üyelik Kartı</strong> bilginiz bulunmamaktadır, Üyelik Kartı alarak fırsatlardan yararlanabilirsiniz</div>');

                    setTimeout(function () {
                        window.location.href = "/Home/Index";
                    }, 3000);

                }
            }
        });

        return false;
    });

    $('.FooterTextShowMore').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowLess').show();
        $('.FooterTextSecondPart').show();
    });

    if (document.URL.indexOf("/outlet") != -1 && $("#MainMenu .outlet").length > 0) {
        $("#MainMenu .outlet").show();
        $("#MainMenu .outlet").prev().hide();
    }

    $('.FooterTextShowLess').on('click', function (e, index) {

        $(this).hide();
        $('.FooterTextShowMore').show();
        $('.FooterTextSecondPart').hide();

    });

    $(".SepetProducts .closeImage").live("click", function () {
        toggleBasket();
        $(".SepetProducts").removeClass("activeBasket");
        $("body").removeClass("BasketDropped");
        $("body").removeClass("BackDropped");
    });


    $("#MainMenu > ul > li").on("click", function () {
        if ($(window).width() < 992 && !$(this).hasClass("TabletMenu") && !$(this).find(".itemsWrapper").length <= 0) {
            $(this).find(".itemsWrapper").slideToggle();
            $(this).toggleClass("minus-icon");
        }
    });

    MobileMenuSetting();
    MenuBannerSettings()

    $("a#ContinueShop").live("click", function () {

        //$("body").removeClass("BackDropped");
        location.reload();

    });

    // AddToFavorite();
    // removeFavorite();

    if ($(window).width < 980) {
        $("#LoginRegisterModal .modal-content").css("background-image", "none");
        $("#LoginRegisterModal .modal-content").removeAttr("style");
    }

    $('.top_link').hide();
    width = $(window).width();

    $('.OpenLeftMenu').hover(function () {
        mouse_is_inside_LeftMenu = true;
    }, function () {
        mouse_is_inside_LeftMenu = false;
    });

    $('.UserAndBasket, .BasketContainer').live({
        mouseenter:
            function () {

                mouse_is_inside_userandBasket = true;

            },
        mouseleave:
            function () {
                mouse_is_inside_userandBasket = false;
            }
    });


    var ThemePath = "/Images/BlackTheme/";

    if ($(".LogoContainer img").length > 0) {
        ThemePath = $(".LogoContainer img:first").attr("src").replace("Logo.png", "");
    }

    //Menu 
    if ($("ul#MainMenu").length > 0) {

        //$("ul#MainMenu").ResponsiveMenu();

    }

    // alert("ismobile:" + isMobile(true) + " IsChrome:" + IsChrome() + " IsFirefox:" + IsFirefox() + "IsSafari:" + IsSafari() + " agent:" + navigator.userAgent.toLowerCase() );

    //if (isMobile(true) && (IsChrome() || IsFirefox() || IsSafari())) {
    //    $("#MainMenu").css("display", "block");
    //}

    $('.carousel').not('.SBanner').carousel();
    $('.SBanner').carousel({
        interval: 3000
    });

    $(".RightAccount").live({

        mouseenter:
            function () {

                if (!isMobile(true) && $(this).find("#AccountMenu").length > 0) {
                    $("body").addClass("BackDropped");
                }

            },
        mouseleave:
            function () {


                if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                    $("body").removeClass("BackDropped");
                    $(".SepetProducts").removeClass("activeBasket");
                    $("ul#MainMenu.Monitor > li").removeClass("open");
                }


            }

    });

    $("#MainMenu > ul > li").live({

        mouseenter:
            function () {

                if (!isMobile(true) && $(this).find(".itemsWrapper").length > 0 && !$("#RegisterLoginModal").is(":visible")) {
                    $("body").addClass("BackDropped");
                }

            },
        mouseleave:
            function () {


                if (!isMobile(true) && $(".SearchModal").css("display") != "block") {
                    $("body").removeClass("BackDropped");
                    $(".SepetProducts").removeClass("activeBasket");
                    $("ul#MainMenu.Monitor > li").removeClass("open");
                }


            }

    });


    //$("body.BackDropped:not(.OpenLeftMenu)").live("click", function () {

    //    HideOpenWindows();

    //});


    //$("body.BackDropped:not(.BasketContainer)").live("click", function () {

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //    if ($(".RightBasket.active").length > 0) {
    //        $(".RightBasket").removeClass("active");
    //    }

    //});



    $("body .backdrop").on("click", function (e) {

        HideOpenWindows();

        $("body").removeClass("LeftMenuOpen BackDropped");
        $("#MainMenu").removeClass("open");

        $("body").removeClass("BasketDropped");
        hideBasket();
        //$(".SearchModal").hide();
        $(".RightBasket, .RightAccount").removeClass("active");
        $(".SepetProducts").removeClass("activeBasket");

    });

    $("body").on("click", function (e) {

        if (!mouse_is_inside_userandBasket) {
            $(".RightBasket.active").removeClass("active");
        }


    });

    $("body #PrdBlackBg").on("click", function (e) {

        $("#PrdBlackBg").hide();
        $(".SizeOptions.open").removeClass("PleaseSelect");
        $(".AddToBasket.PleaseSelect").removeClass("PleaseSelect");
        $(".ProductOptions").removeClass("PleaseSelectFixedArea");
        if ($(".AutoTextRep").length > 0) {
            $(".AutoTextRep button").text($(".AutoTextRep button").attr("data-first"));
        }

        if ($(window).width() > 767) {
            $(".ProductOptions").css("position", "fixed");
            $("body").css("overflow", "unset");
        }

    });

    $('.top_link').click(function () {

        $('html, body').animate({ scrollTop: 0 }, 'slow');

    });

    $(window).scroll(function () {

        if ($(window).width() > 767) {
            if ($('.top_link').length > 0) {

                if ($(window).scrollTop() > showTopLink) {
                    $('.top_link').fadeIn('slow');
                } else {
                    $('.top_link').fadeOut('slow');
                }

            }
        }

        if ($(window).scrollTop() > showTopLink) {

            $("body").addClass("Scrolled");

            if ($("#AnoncementArea").hasClass("ActiveAnoncement")) {
                $("body").removeClass("ActiveAnoncementBanner");
            }

        } else {
            $("body").removeClass("Scrolled");

            if ($("#AnoncementArea").hasClass("ActiveAnoncement")) {
                $("body").addClass("ActiveAnoncementBanner");
            }

        }


    });


    var rtime;
    var timeout = false;
    var delta = 500;

    $(window).resize(function () {

        rtime = new Date();
        if (timeout === false) {
            timeout = true;
            setTimeout(resizeend, delta);
        }
    });

    function resizeend() {
        if (new Date() - rtime < delta) {
            setTimeout(resizeend, delta);
        } else {
            timeout = false;

            SetWindowSize();

        }
    }

    $('.bottomMenu p').click(function () {

        $(this).parent().toggleClass("open");

    });

    $("#CurrencySelectionDr").on("click", ".CurrencyItem", function () {

        var hs = window.location.hash;
        hs = hs.replace("=", "[_]");
        hs = hs.replace("&", "[and]")
        var CurrencyID = $(this).attr("data-id");

        $(".CurrenctCur img").attr("src", $(this).find("img").attr("src"));
        $(".CurrenctCur .TL").html($(this).find(".TL").html());
        $(".CurrenctCur .CurrCode").html($(this).find(".CurrCode").html());

        $.ajax({
            type: 'get',
            url: '/Home/ChangeCurrency',
            data: 'Url=' + window.location.pathname + "&currencyID=" + CurrencyID + "&hash=" + window.location.hash,
            success: function (dt) {

                window.location.reload(true);

            }
        });


    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });

    $(".CloseModal").on("click", function () {
        $(this).parents(".modal").modal('hide');
    });


    $(".btn-back").live("click", function () {

        $(this).closest("form").slideUp();

    });

    TagAutoComplate();

    $('body').on('hidden.bs.modal', '.modal', function () {
        $(this).removeData('bs.modal');
    });

    //$('.help_Uyelik, .help_Uyelik .subhelp').hide();
    $('.help_Uyelik, .help_Uyelik .subhelp:first').show();
    $('#helpMenu ul li:first a').addClass("secili");

    //if ($('.helpmenu li a').length > 0) {

    //Help Menu

    $('#helpMenu ul li a').on('click', function (e, index) {

        $('#helpMenu ul li a').removeClass('secili');
        $(this).addClass('secili');
        GetHelp($(this).attr('href').replace(/#/ig, ""));
    });

    $('.subhelptitle').on('click', function (e, index) {


        var c = $(this).attr('id').replace(/title/, "");
        $('.subhelp:visible').slideUp('fast');
        $('.' + c).slideDown('fast');

    });

    $("#HelpNavs div ul").first().show();
    $("#HelpContents ul li").hide();
    $("#HelpContents div").eq($("#HelpNavs div .HelpNavTitles").first().parent().index()).find("ul li:first").show();


    $('#HelpNavs li').click(function () {

        $("#HelpContents ul li").hide();

        $("#HelpContents div").eq($(this).closest("div").index()).find("ul li").eq($(this).index()).show();

    });

    $('#HelpNavs > div').click(function () {


        $("#HelpNavs div > ul").hide();
        $(this).find("ul").show("normal");


    });

    $('.HelpNavTitles').click(function () {

        $("#HelpContents ul li").hide();
        $("#HelpContents div").eq($(this).parent().index()).find("ul li:first").show();

    });

    //$('.close-basket').live('click', function (e) {
    //    $("body").removeClass("BasketDropped");
    //    $("body").removeClass("BackDropped");
    //    toggleBasket();
    //});


    function hideBasket() {
        $(".SepetProducts").stop().animate({ "left": "100%" }, 200, function () {
            $(".SepetProducts").stop().hide();
            $("body").removeClass("BasketDropped");
        });
    }

    function showBasket() {

        if ($(window).width() > 1199 && $(window).width() > 1510) {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        } else {
            $(".SepetProducts").stop().animate({ "left": "75%" }, 200, function () {
                setContentHeight();
                $(".SepetProducts").stop().show();
                $("body").addClass("BasketDropped");
            });
        }


    }


    $('.RightBasket a').live('click', function (e) {

        if (!isMobile(true)) {
            e.preventDefault

            var isCartActive = $(".RightBasket").hasClass("active");


            $(".RightBasket").addClass("active");

            $(".RightAccount").removeClass("active");
            toggleBasket();


            if (!isCartActive) {
                e.preventDefault;
                return false;
            }

        }

    });

    $('.RightAccount').live('click', function (e) {

        if (isMobile(true)) {

            var isCartActive = $(".RightAccount").hasClass("active");

            $("body").addClass("BackDropped");
            $(".RightAccount").addClass("active");
            $(".RightBasket").removeClass("active");

            if (!isCartActive) {
                e.preventDefault;
                return false;
            }

        }

    });




    if ($("#UserAndBasket").length > 0) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
            data: "",
            async: true,
            cache: false,
            contentType: "application/json; charset=utf-8",
            dataType: 'text',
            success: function (dt) {


                $("#UserAndBasket").html(dt);



                if ($("#LangRedirectNeed").length > 0) {

                    //  changeSiteLanguage("0", $("#LangRedirectNeed").val());
                }

                if ($("#LangSelectionNeed").length > 0) {
                    ShowLangAreaForChange();
                }

                if ($("#WindowSizeNotSetted").length > 0) {

                    SetWindowSize();
                }

                if (UseTagManager) {

                    AddGeneralInfoTagManager('', dtIsLogged, dtUserID);

                    AddProductView('');
                    var promotions = GetPromotionsVariable('');
                    AddImpression('', promotions);
                    //  AddGASliderView('');

                    SendGaDataLayerVirtual();
                }

                var UserID = $("#UserID").val();

                if (UserID != undefined && UserID > 0) {
                    Isfollow();
                }
                GetMemberCardPrice();
            }
        });

    }

    SetWindowSize();

    function setBasketContainerHeight() {
        var ContentHeight = $(".SepetProducts").height() - 360;
        $(".BasketCenterContent").height(ContentHeight);
        $(".BasketCenterContent").css("max-height", ContentHeight);

        $(window).resize(function () {
            var ContentHeight = $(".SepetProducts").height() - 360;
            $(".BasketCenterContent").height(ContentHeight);
            $(".BasketCenterContent").css("max-height", ContentHeight);
        });

    }

    $(".BasketContainer .RemoveIcon").live("click", function () {

        var currencyCode = $("#ForMemberCardCurrencyCode").val();
        var currentCurrencyCode = "";
        if (currencyCode != undefined) {
            currentCurrencyCode = currencyCode;
        }

        var Silid = 0;

        if ($(this).attr("data-id") != undefined && $(this).attr("data-id").length > 0) {

            Silid = $(this).attr("data-id").replace("sepetsil", "");
        }

        var gizlenecekSecim = $(this).parent().parent();
        var nameOfCurItem = "";
        if ($(this).closest(".SepetRow").length > 0) {

            gizlenecekSecim = $(this).closest(".SepetRow");
            nameOfCurItem = $(gizlenecekSecim).find(".SepetPrdHeader").text();
        }
        var LangID = $("#LangID").val();

        $(gizlenecekSecim).find(".ustSepetAjaxLoader").show();
        $(gizlenecekSecim).find(".ustSepetDelete").hide();
        $(gizlenecekSecim).css("opacity", "0.5");

        dataall = "";

        if ($(this).attr("data-all") == "true") {

            dataall = "&all=true";
            gizlenecekSecim = $(".SepetProducts");
        }

        if (1 == 1 || $(".ProductDetail").length > 0) {
            dataall += "&pd=true";
        }

        $removedItem = $(gizlenecekSecim).clone();

        $.ajax({
            type: 'get',
            url: '/' + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID + dataall,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == true) {

                    if (dt.JsonRs != null && dt.JsonRs != undefined && dt.JsonRs != "") {
                        window.dataLayer = window.dataLayer || [];
                        dataLayer.push({
                            "event": "eec.remove",
                            "ecommerce": {
                                "remove": {
                                    "actionField": {
                                        "list": "Product Detail"
                                    },
                                    "products": [JSON.parse(dt.JsonRs)]
                                }
                            }
                        });
                    }

                    $.ajax({
                        type: 'get',
                        url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                        data: "",
                        async: true,
                        contentType: "application/json; charset=utf-8",
                        dataType: 'text',
                        success: function (dt) {

                            $("#UserMenus  #UserAndBasket").html(dt);

                            $('html, body').animate({ scrollTop: 0 }, 'slow');

                            $(".RightBasket").addClass("active");
                            $("body").addClass("BackDropped");

                            $(".SepetProducts").hide();
                            $(".SepetProducts").addClass("activeBasket");
                            setBasketContainerHeight();
                            $(".AjaxLoader").hide();



                        }
                    });

                }
                else {

                    alert(dt.IslemSonucAciklama);
                }

            }
        });


    });

    if (isMobile(true)) {

        $("#PayNow").live("mouseenter", function (e) {

            document.location.href = $(this).attr("href");

        });
    }

    $('.RightSearch').live('click', function (e) {
        //console.info($("body").hasClass("Scrolled"));

        //if ($("body").hasClass("Scrolled")) {

        //    $("body").addClass("Scrolled");
        //    $("body").addClass("BackDropped");

        //}
        //else {
        //    $("body").addClass("BackDropped");
        //}


        //$(".SearchModal").show();

        //$(".SearchModal input:first").focus();
        //$('html, body').animate({ scrollTop: 0 }, 'slow');


    });

    $('.headerSearchButton').live('click', function (e) {

        //$("body").addClass("BackDropped");
        //$(".SearchModal").show();

        //$(".SearchModal input:first").focus();
        //$('html, body').animate({ scrollTop: 0 }, 'slow');

        $(".search-new").css("display", "block");
        $("#SearchNewText_Close").css("display", "block");
        $("#SearchNewText_Search").css("display", "block");
        if ($(window).width() < 767) {
            $("#UserMenus").css("width", "100%");
        }
        $("#SearchForm_New #search").focus();
    });

    $("#SearchNewText_Close").live("click", function () {

        $(".search-new").css("display", "none");
        $("#SearchNewText_Close").css("display", "none");
        $("#SearchNewText_Search").css("display", "none");
        $(".NewHome header").removeClass("mouseOn");
        if ($(window).width() < 350) {
            $("#UserMenus").css("width", "40%");
        }
        else if ($(window).width() < 767) {
            $("#UserMenus").css("width", "50%");
        }
    });


    $('.OpenLeftMenu, .CloseLeftMenu, .ToggleMMenuIcon , .MainIcon').live('click', function (e) {
        $("#Mainmenu ul li div.itemsWrapper").hide();
        $("#MainMenu").toggleClass("open");

        if ($("#MainMenu").hasClass("open") == true) {
            $("body").addClass("BackDropped LeftMenuOpen");
            $(".NewHome header").addClass("mouseOn");
        }
        else {
            $("body").removeClass("BackDropped LeftMenuOpen");
            $(".NewHome header").removeClass("mouseOn");
        }

    });

    $('.SearchModal form input').keyup(function (event) {

        if (event.keyCode == 27) {

            $("body").removeClass("BackDropped");
            $(".SearchModal").hide();

        }
    });

    $('.CloseSearch').click(function (event) {


        $("body").removeClass("BackDropped");
        $(".SearchModal").hide();

    });

    if ($("#FbConfirmMergeModal").length > 0) {

        $("#FbConfirmMergeModal").modal("show");

    }

    if ($("#FbMergeResultModal").length > 0) {

        $("#FbMergeResultModal").modal("show");

    }


    if (window.location.hash == "#Rg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $("#LineRg").offset().top + -80
        }, 500);

    }

    if (window.location.hash != undefined && document.URL.indexOf("Yardim") > 0) {

        var curHash = window.location.hash.replace("#", "");

        $("#helpMenu a[href$='" + curHash + "']").trigger("click");
    }


    if (window.location.hash == "#Lg" && isMobile(true)) {


        $('html, body').animate({
            scrollTop: $(".GeneralBreadCrumb:first").offset().top + -50
        }, 500);


    }


    $(".ForgetPass").on("click", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $(".PopupRegisterBanner").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $(".RegisterInBanner").on("click", function (e) {

        $(".LoginRegisterContainer").toggle();
        $(".LoginRegisterContainer").closest(".row-fluid, .row").toggle();
        $(".PopupRegisterBannerContainer").toggleClass("Bordered");

        $("li.tb").removeClass("active");

        if (isMobile(true)) {

            $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

            if ($(".UyeOlModal:visible").length > 0) {

                $("li.tb.reg").addClass("active");

            }
            else {

                $("li.tb.log").addClass("active");

            }

        } else {

            if ($(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").hasClass("pull-right")) {

                $(this).text($(this).attr("data-cur"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").removeClass("pull-right");

                $("li.tb.reg").addClass("active");


            }
            else {

                $(this).text($(this).attr("data-other"));
                $(this).closest("div.RwRegisterLogin").find("div.UyeKayitCol").addClass("pull-right");

                $("li.tb.log").addClass("active");

            }

        }

        $cur = $(".LoginRegisterContainer");

        $cur.css("opacity", "0.1");

        $cur.animate({
            opacity: 1
        }, 500, function () {
        });


    });


    $(".LogRegTabs li").on("click", function (e) {

        $(".RegisterInBanner").click();

    });


    $("#PayNow").on("click", function (e) {

        document.location.href = $(this).attr("href");

    });
    $(".ModalTab").on("click", function (e) {

        $(".ModalTab").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("Login")) {
            $(".LoginRow").show();
            $(".RegisterRow").hide();
        }
        else {

            $(".LoginRow").hide();
            $(".RegisterRow").show();
        }


    });

    //$("#AccountMenu a.LoginIcon, #AccountMenu a.RegisterIcon").live("click", function (e) {

    //    if ($("#LoginRegisterModal").length > 0) {

    //        $("#LoginRegisterModal").modal("show");

    //        if ($(this).hasClass("RegisterIcon") == true) {
    //            $(".ModalTab.Register").trigger("click");
    //        }
    //        else {
    //            $(".ModalTab.Login").trigger("click");
    //        }

    //        e.preventDefault();
    //        return false;
    //    }

    //});



    if ($("#WelcomeModal").length > 0) {

        $('#WelcomeModal').modal({
            // backdrop: "static"
        });

    }

    $("form.UyeOlModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("SignUp");
                    }

                    if (dt.JsonRs == "Redirect") {

                        if (dt.Deger5.length > 0) {

                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }
                    else if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeGirisModal").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }


                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });

        return false;


    });

    $("#RegisterLoginModal .EmailImg").live("click", function () {
        $("#RegisterLoginModal input[name='login.UserName']").val('');
    });

    $("#RegisterLoginModal .PasswordImg").on("mousedown", function () {
        $("#RegisterLoginModal input[name='login.Password']").attr("type", "text");
    });

    $("#RegisterLoginModal .PasswordImg").on("mouseup", function () {
        $("#RegisterLoginModal input[name='login.Password']").attr("type", "password");
    });

    $("#RegisterLoginModal .PasswordImg").on("mouseleave", function () {
        $("#RegisterLoginModal input[name='login.Password']").attr("type", "password");
    });

    //PRODUCTS HOVER 
    $(".ProductList .Prd a").live('click', function (e) {

        if (UseTagManager == true) {

            AddGaEvent('', 'Product List', 'Product Click', $(this).closest(".Prd"));

        }

        //return false;
        //e.preventDefault();


    });

    var ScrollContentID = "LastScrollTop" + $("#PID").val();

    $('.ProductList .Prd').live("click", function (e) {
        $.cookie(ScrollContentID, null, { expires: -1 });
        $.cookie(ScrollContentID, $(window).scrollTop(), { expires: 0.05 });
    });

    $('.ProductListColorContainer div.ProductListColor:not(.passive)').live("click", function () {
        var $currentColor = $(this);

        $(".AjaxLoader").show();

        //var productID = $(this).closest(".Prd").find("a:first").attr("data-product");
        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var item_unique_id = $(this).attr("data-item-unique-id");
        var sizeID = $(this).attr("data-size");
        var params = "ColorID=" + colorID + "&ProductID=" + productID;
        if (typeof sizeID === "undefined") { //size değilde color tıklanmışsa
            sizeID = 0;

            $detailLinks = $(this).closest(".Prd").find("a");

            $currentColor.closest(".ProductListColorContainer").find(".ProductListColor").removeClass("active");

            $currentColor.addClass("active");

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetImageOfColors",
                data: params,
                success: function (data) {
                    $(".AjaxLoader").hide();

                    $Crs = $("#Crs_" + item_unique_id);
                    $Crs.find("div.carousel-inner").html("");

                    var urlNew = "/";
                    if (data.ProductUrl != undefined && data.ColorUrl != undefined) {
                        urlNew += $("#SmallLangCode").val() + "/" + data.ColorName + "-" + data.ProductUrl + data.ColorUrl;
                    }

                    var lazyImage = data.LazyImage;

                    if (data.ImageItems != null && data.ImageItems.length > 0) {
                        for (var i = 0; i < data.ImageItems.length; i++) {
                            var imgJpg = data.ImageItems[i].ImagePath;
                            var imgWebp = data.ImageItems[i].ImagePathWebp;

                            var ImageItem = "<div class='item " + (i == 0 ? "active" : "") + "'><a href='" + urlNew + "'><picture>";

                            if (imgWebp != null)
                                ImageItem += "<source data-srcset='" + imgWebp + "' type='image/webp' />";

                            ImageItem += "<source data-srcset='" + imgJpg + "' type='image/jpeg' />";
                            ImageItem += "<img class='lazyload' data-src='" + imgJpg + "' src='" + data.LazyImage + "' />"
                            ImageItem += "</picture></a></div>";
                            
                            $Crs.find("div.carousel-inner").append(ImageItem);
                        }
                    }

                    //AddToCart attributeleri değiştir
                    $currentColor.closest(".Prd").find(".AddToCart").attr("data-colorid", data.ColorID);
                    $currentColor.closest(".Prd").find(".AddToCart").attr("data-productid", data.ProductID);
                    $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", data.SizeID);

                    $currentColor.closest(".Prd").find(".ProductBadge").html("");

                    //sistemde tanımlı badgeler varsa eklenmeli.
                    if (data.BadgeImagePath != null && data.BadgeImagePath != undefined && data.BadgeTur != 14) {


                        if (data.BadgeTur == 7) {

                            $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');

                        } else if (data.BadgeTur == 8) {

                            $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-top-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                        } else if (data.BadgeTur == 9) {

                            $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-right-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');


                        } else if (data.BadgeTur == 10) {

                            $currentColor.closest(".Prd").find(".ProductBadge").html('<div class="badge badge-left-bottom-padding"><img src="' + data.BadgeImagePath + '" /></div>');
                        }

                        if (data.Amount < data.AmountOld) {

                            //$currentColor.closest(".Prd").find(".ProductBadge").prepend('<div class="badge badge-right-top-padding"><div class="ImgAndDiscount"><img src="images/ALV/badge/indirim_bagde.png" /><span class="discount"> ' + data.DiscountRate + '%</span></div></div>');
                            if ($("#SmallLangCode").val() === "tr") {
                                $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/ALV/badge/indirim_bagde.png'></div>");

                            }
                            else if ($("#SmallLangCode").val() === "en") {
                                $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/ALV/badge/discount_badge.png'></div>");

                            }
                            else if ($("#SmallLangCode").val() === "fr") {
                                $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-right-top-padding'><img src='/images/ALV/badge/rabais_badge.png'></div>");

                            }
                        }

                    }

                    if (data.TotalQuantity <= 0) {
                        $currentColor.closest(".Prd").find(".AddToCart").addClass("passive");
                        $currentColor.closest(".Prd").find(".AddToCart").attr('disabled', 'disabled');

                        if ($("#SmallLangCode").val() === "tr") {
                            $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding' style='z-index:1'><img src='/images/ALV/badge/tukendi.png'></div>");

                        }
                        else if ($("#SmallLangCode").val() === "en") {
                            $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/ALV/badge/sold_out.png'></div>");
                        }
                        else if ($("#SmallLangCode").val() === "fr") {
                            $currentColor.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/ALV/badge/epuise.png'></div>");
                        }
                    }

                    else {
                        $currentColor.closest(".Prd").find(".AddToCart").removeClass("passive").removeAttr("disabled");
                    }

                    if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                        var swparams = GetSwPageParams();

                        swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "UrunRenkDegistirme");

                        swparams = ChangeSwHashedStringParamValue(swparams, "ProductID", productID);
                        swparams = ChangeSwHashedStringParamValue(swparams, "ColorID", colorID);

                        AddSwAction(swparams);

                    }
                },
                error: function (xhr, status, error) {
                    var data = xhr.responseText;
                    var jsonResponse = JSON.parse(data);

                    alert(' HATA: ' + jsonResponse["Data"] + '\r\n' + 'status: ' + status + '\r\n' + ' error text: ' + error + '\r\n');
                }
            });

            //size divini yenilesin
            $currentColor.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();
        }
    });

    $('.ProductListSizeContainer div.ProductListSize:not(.passive)').live("click", function () {
        var $currentColor = $(this);

        $(".AjaxLoader").show();

        var productID = $(this).attr("data-color-product-id");
        var colorID = $(this).attr("data-color");
        var sizeID = $(this).attr("data-size");

        $currentColor.closest(".Prd").find(".AddToCart").attr("data-sizeid", sizeID);
        $currentColor.closest(".ProductListSizeContainer").find(".ProductListSize").removeClass("active");

        $currentColor.addClass("active");

        $currentColor.closest(".Prd").find(".AddToCart").click(); //sepet eklesin hemen
        $(".AjaxLoader").hide();
    });
    
    //SEPETE EKLE
    $(".ProductList .Prd .AddToCartArea button.AddToCart").die("click").live("click", function (e) {

        $basketButton = $(this);

        var SizeID = $basketButton.attr("data-sizeid");
        var ColorID = $basketButton.attr("data-colorid");
        var ProductID = $basketButton.attr("data-productid");
        var LangID = $("#SmallLangCode").val();
        var Amount = "1";



        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "" && SizeID != "0" && ColorID != "0" && ProductID != "0") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {

                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header h3").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus  #UserAndBasket").html(dt);

                                //$('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");
                                setBasketContainerHeight();
                                $(".AjaxLoader").hide();

                                $basketButton.closest("div.AddToCartArea").find("button.AddToCart").attr("data-sizeid", "0");
                                $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").remove();

                            }
                        });

                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });


        }
        else if (SizeID === "0" && $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").length === 0) {

            var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSizeOfColors",
                data: params,
                success: function (data) {

                    $(".AjaxLoader").hide();

                    //$basketButton.closest("div.AddToCartArea").find("div.ProductListColorContainer").after(data);
                    $basketButton.closest("div.AddToCartArea").find("button.AddToCart").before(data);
                    var $firstSize = $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize.active:first");

                    var firstSizeId = ($firstSize.length > 0 ? $firstSize.attr("data-size") : 0);

                    $basketButton.removeClass("passive");

                    if (firstSizeId === 0) {
                        $basketButton.addClass("passive");

                        if ($("#SmallLangCode").val() === "tr") {
                            $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/ALV/badge/tukendi.png'></div>");

                        }
                        else if ($("#SmallLangCode").val() === "en") {
                            $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/ALV/badge/sold_out.png'></div>");
                        }
                        else if ($("#SmallLangCode").val() === "fr") {
                            $basketButton.closest(".Prd").find(".ProductBadge").prepend("<div class='badge badge-left-top-padding'><img src='/images/ALV/badge/epuise.png'></div>");
                        }
                    }

                    //***** ilk size id default seçili gelmesin dediler. o yüzden AddToCarta sizeid yazmasın ve size kutularındaki active kaldırılıyor. 
                    //$basketButton.attr("data-sizeid", firstSizeId);
                    $basketButton.closest("div.AddToCartArea").find("div.ProductListSizeContainer.plSize").find(".ProductListSize").removeClass("active");
                },
                error: function () {

                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                }
            });
        }

        e.preventDefault();
        return false;

    });


    if ($(".ContentPgArea").length > 0 && isMobile(true)) {
        $('html, body').animate({ scrollTop: $(".ContentPgArea").offset().top }, 'slow');
    }


    $("form.ForgettenForm").live("submit", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);


                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();

                    $(".ForgettenForm p:first").removeClass("alert-error");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    alert(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-error");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.UyeOl").live("submit", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();
        $(".Header1, .Header2").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");


                if (dt.Sonuc == true) {

                    if (dt.JsonRs == "Redirect") {
                        if (dt.Deger5.length > 0) {
                            document.location = dt.Deger5;
                        }
                        else {
                            document.location = "/";
                        }
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();

                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                    $form.hide();

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }
                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    $("form.InfLoginModal").live("submit", function () {

        $form = $(this);
        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {
                    document.location = dt.Deger5;

                }
                else {


                    $("#AlertResultLogin").removeClass("alert-success");
                    $("#AlertResultLogin").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);

                    //$('html, body').animate({ scrollTop: 280 }, 'slow');


                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });
    $("form.InfRegisterModal").live("submit", function () {


        $form = $(this);


        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                    // alert("tesst");
                    // $('html, body').animate({ scrollTop: 280 }, 'slow');


                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("form.InfRegisterDetailsModal").live("submit", function () {


        $form = $(this);


        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                if (dt.Sonuc == true) {

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                    // alert("tesst");
                    // $('html, body').animate({ scrollTop: 280 }, 'slow');


                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });



    var utm_source = getQuery(window.location.href).utm_source;
    var utm_campaign = getQuery(window.location.href).utm_campaign;
    var utm_medium = getQuery(window.location.href).utm_medium;

    if ((utm_source != undefined && utm_source.length > 0) || (utm_campaign != undefined && utm_campaign.length > 0) || (utm_medium != undefined && utm_medium.length > 0)) {

        $.ajax({
            url: "/" + $("#SmallLangCode").val() + "/p/User/SetUtmParam",
            data: "utm_source=" + utm_source + "&utm_campaign=" + utm_campaign + "&utm_medium=" + utm_medium,
            type: "POST",
            cache: false
        });

    }

    $("#SwitchNewLayout").live("click", function () {

        changeSiteTheme($(this).attr("data-ly"));

    });

    $(".BasketContainer .SepetRow").live("swiperight", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $(".BasketContainer .SepetRow").live("swipeleft", function () {

        $(this).find(".RemoveIcon").trigger("click");

    });

    $("#SingOut").live("click", function (e) {

        if (UseTagManager) {
            AddUserAction("Signout");
        }
        //e.preventDefault();
        //return false;

    });

    if (1 == 2 && $("#homebannerFull1").length > 0 && !isMobile(true)) {
        $(document).snowfall('clear');
        $(document).snowfall({ shadow: true, round: true, minSize: 1, maxSize: 5, flakeCount: 200 }); // add shadows

    }


    if ($(window).width() > 1000) {


        $("#LoginRegisterModal .Login").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

        $("#LoginRegisterModal .Register").live("click", function (e) {
            $('#LoginRegisterModal .modal-content').css();
        });

    }

});